import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import R from 'ramda';

import SurveyRouter from '_routers/SurveyRouter';

import ActivityIndicator from '_atoms/ActivityIndicator';

import { attemptGetSurveys } from '_thunks/surveys';

export default function SurveyPage(pathname) {
    const dispatch = useDispatch();
    const { surveys } = useSelector(R.pick(['surveys']));

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(attemptGetSurveys())
            .catch(R.identity)
            .then(() => setLoading(false));
    }, []);

    useEffect(() => {
        //console.log(surveys);
    }, [surveys]);

    return (
        <div className="survey-page page">
            {loading ? <div className="full_wrapper"><ActivityIndicator /></div> : <SurveyRouter survey={surveys.find(s => s.base_uri == pathname.location.pathname.split('/')[2])} />}
        </div>
    );
}